<template>
    <div :class="classMainBlock">
        <label v-if="title">
            {{ title }}
        </label>
        <vue-multiselect
            ref="multiselect"
            v-model="itemModel"
            :close-on-select="false"
            :clear-on-select="false"
            :disabled="disabled"
            :maxHeight="200"
            :multiple="true"
            :max="max"
            :internal-search="false"
            :options="filteredOptions"
            :searchable="searchable"
            :show-labels="false"
            label="name"
            :placeholder="placeholder"
            track-by="id"
            :block-keys="keys"
            @input="onChange"
            @remove="$emit('remove', $event)"
            @search-change="onSearchChange"
        >
        </vue-multiselect>
    </div>
</template>

<script>
export default {
    props: ['title', 'id', 'searchable', 'text', 'items', 'selected', 'route', 'classMainBlock', 'classSelect', 'placeholder', 'disabled', 'max'],
    data: function () {
        return {
            itemModel: [],
            itemsData: [],
            filteredOptions: [],
            keys: ['Enter'],
        };
    },
    watch: {
        itemsData() {
            this.filteredOptions = this.itemsData;
        },
    },
    mounted() {
        this.getItems();

        let el = this.$refs.multiselect.$el.getElementsByTagName('input')[0];
        if (el) {
            el.addEventListener('keypress', this.onKeyPress);
        }
    },
    methods: {
        onChange() {
            this.emitChange();

            if (this.filteredOptions.length <= 1) {
                this.$refs.multiselect.search = '';
            }
        },
        onKeyPress(e) {
            const search = this.$refs.multiselect.search.trim();
            const pointer = this.$refs.multiselect.pointer;
            const selectedItem = this.filteredOptions[pointer] || null;

            switch (e.code) {
                case 'Enter':
                    if (selectedItem) {
                        let ids = this.getValue();
                        if (!ids.includes(selectedItem.id)) {
                            ids.push(selectedItem.id);
                            this.setModel(ids);
                        }
                    } else {
                        this.parseSearch(search);
                    }

                    this.$refs.multiselect.deactivate();
                    break;

                case 'Space':
                    this.parseSearch(this.$refs.multiselect.search);
                    break;
            }
        },
        onSearchChange(query) {
            if (query && query.length > 0) {
                const isIncludeSubstr = (item) => item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                this.filteredOptions = this.itemsData.filter(isIncludeSubstr);
            } else {
                this.filteredOptions = this.itemsData;
            }
            if (query.trim().includes(' ')) {
                this.parseSearch(query);
            }
        },
        parseSearch(query) {
            if (query.length === 0) return;

            let ids = this.getValue();
            query
                .split(' ')
                .map((id) => +id)
                .filter((id) => id > 0)
                .forEach(function (id) {
                    if (!ids.includes(id)) ids.push(id);
                });

            this.setModel(ids);
            this.$refs.multiselect.search = '';
            this.emitChange();
        },
        sortItemsById(items) {
            return items.sort((a, b) => {
                return b['id'] - a['id'];
            });
        },
        getItems() {
            if (this.items) {
                this.itemsData = this.sortItemsById(this.items || []);
                this.setModel(this.selected);
                this.selected && this.emitChange();
                this.emitSetItems();
            } else if (this.route) {
                axios.get(this.route).then((response) => {
                    this.itemsData = this.sortItemsById(response.data);
                    this.setModel(this.selected);
                    this.selected && this.emitChange();
                    this.emitSetItems();
                });
            }
        },
        getValue() {
            return this.itemModel.map((item) => item.id);
        },
        setModel(ids) {
            this.itemModel = ids ? this.itemsData.filter((value) => ids.indexOf(value.id) !== -1) : [];
        },
        setModelAndValue(ids) {
            this.setModel(ids);
        },
        emitChange() {
            this.$emit('change', this.getValue());
        },
        emitSetItems() {
            this.$emit('setItems', this.itemsData, this.id);
        },
        clear() {
            this.itemModel = [];
        },
    },
};
</script>
